/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getAllCadresActions, {
    getAllCadresTypes,
} from '../../../redux/cadre/getAllCadres'
import { Get } from '../../../serveur/axios'

function* getAllCadresSagas({ response }) {
    try {
        const responseAdd = yield Get('cadredirection/')
        if (responseAdd.status === 200) {
            yield all([
                yield put(getAllCadresActions.getAllCadresSuccess(responseAdd.data.data)),
            ])
        }
        else
            yield put(getAllCadresActions.getAllCadresFailure(responseAdd.data))

    } catch (error) {
        yield put(getAllCadresActions.getAllCadresFailure(error))
    }
}

export function* getAllCadresSaga() {
    yield takeLatest(
        getAllCadresTypes.GET_ALL_CADRES_REQUEST,
        getAllCadresSagas
    )
}
